import React from 'react';
import { Flex, Button } from 'rebass';
import links from '../../links';

const pill = (night) => ({
  px: 3,
  py: 2,
  fontSize: 14,
  borderRadius: 9999,
  bg: night ? 'rgba(255,255,255,0.04)' : '#f3f4f6',
  color: night ? '#fff' : '#0b1220',
  boxShadow: '0 1px 2px rgba(16,24,40,0.04)',
  transition: 'transform 120ms ease, box-shadow 120ms ease',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 8px 24px rgba(16,24,40,0.08)'
  },
  width: ['100%', 'auto'], // full width on small screens, auto on larger
  textAlign: 'center',
  display: 'inline-block',
  mr: 2,
  mb: [2, 0]
});

const LinksRow = ({ night }) => (
  <Flex sx={{ flexWrap: 'wrap', alignItems: 'center', gap: 12, mt: 3 }}>
    {links.map((l) => (
      <Button
        key={l.href}
        as="a"
        href={l.href}
        title={l.description}
        target="_blank"
        rel="noopener noreferrer"
        sx={pill(night)}
      >
        {l.label}
      </Button>
    ))}
  </Flex>
);

export default LinksRow;